exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "account-registration .relative-pos{position:relative}account-registration .invitations-row{position:absolute;top:5px;right:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/pages/account-registration/account-registration.scss
// module id = 1265
// module chunks = 0